export class CloseContactUser {
  constructor(
    public name: string,
    public ic: string,
    contactNumber: string,
    public stationName: string,
    public timestamp: string
  ) {}
}
